module.exports = __webpack_public_path__ + "static/media/crypto.d3ef43c1.png";